(() => {
  // src/recommendation-auto-mount.ts
  (() => {
    const PLACEMENT_SELECTOR = "[data-recommendation-placement]";
    const IMPRESSION_THRESHOLD = 0.45;
    const DEFAULT_LIMIT = 8;
    const DEFAULT_INTENT = "related";
    const log = (...args) => {
      var _a;
      if ((_a = window.HotelCollection) == null ? void 0 : _a.debugRecommendations) console.log("[recs:auto-mount]", ...args);
    };
    let impressionObserver = null;
    const ensureImpressionObserver = () => {
      if (impressionObserver) return impressionObserver;
      impressionObserver = new IntersectionObserver(
        (entries) => {
          var _a, _b;
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const card = entry.target;
            impressionObserver == null ? void 0 : impressionObserver.unobserve(card);
            const productId = card.dataset.upsellProductId;
            if (!productId) continue;
            const placement = card.closest(PLACEMENT_SELECTOR);
            const placementId = (_b = (_a = placement == null ? void 0 : placement.dataset.placementId) != null ? _a : placement == null ? void 0 : placement.id) != null ? _b : "unknown";
            document.dispatchEvent(
              new CustomEvent("recommendation:impression", {
                detail: { productId, placementId }
              })
            );
          }
        },
        { threshold: IMPRESSION_THRESHOLD }
      );
      return impressionObserver;
    };
    const mount = async (el) => {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      if (el.dataset.recommendationMounted) return;
      el.dataset.recommendationMounted = "true";
      const engine = (_a = window.HotelCollection) == null ? void 0 : _a.RecommendationEngine;
      if (!engine) {
        log("no engine on window \u2014 provider scripts not loaded yet");
        return;
      }
      const productId = el.dataset.productId;
      if (!productId) {
        log("missing data-product-id, skipping", el);
        return;
      }
      const limit = Number((_b = el.dataset.limit) != null ? _b : DEFAULT_LIMIT);
      const intent = (_c = el.dataset.intent) != null ? _c : DEFAULT_INTENT;
      const title = el.dataset.title;
      const superTitle = el.dataset.superTitle;
      const description = el.dataset.description;
      const sourceId = el.dataset.sourceId;
      const trackImpressions = el.dataset.trackImpressions !== "false";
      const placementId = (_e = (_d = el.dataset.placementId) != null ? _d : el.id) != null ? _e : "auto";
      log("mount", { placementId, productId, intent, limit, sourceId });
      const result = await engine.fetchHtml({ productId, limit, intent, sourceId });
      if (!result.html) {
        el.hidden = true;
        log("empty response, hiding placement", placementId);
        return;
      }
      const finalSuperTitle = (_f = result.superTitle) != null ? _f : superTitle;
      const finalTitle = (_g = result.title) != null ? _g : title;
      const finalDescription = (_h = result.description) != null ? _h : description;
      const heading = (finalSuperTitle ? `<p class="recommendation-placement__super-title">${finalSuperTitle}</p>` : "") + (finalTitle ? `<h6 class="recommendation-placement__title">${finalTitle}</h6>` : "") + (finalDescription ? `<p class="recommendation-placement__description">${finalDescription}</p>` : "");
      el.innerHTML = heading + result.html;
      if (trackImpressions) {
        const observer = ensureImpressionObserver();
        el.querySelectorAll("[data-upsell-product-id]").forEach((c) => observer.observe(c));
      }
    };
    const scan = (root = document) => {
      const nodes = root.querySelectorAll(PLACEMENT_SELECTOR);
      nodes.forEach(mount);
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => scan(), { once: true });
    } else {
      scan();
    }
    document.addEventListener("shopify:section:load", (e) => scan(e.target));
  })();
})();
